import { useDaumPostcodePopup } from "react-daum-postcode";
import { Address } from "react-daum-postcode/lib/loadPostcode";
import InputText from "components/atoms/input/Text";
import Btn from "components/atoms/buttons";

interface Props {
  className?: string;
  addressState: {
    postCode?: string;
    baseAddress?: string;
    detailAddress?: string;
  };
  chageEvent: {
    onChageDetail: (address: string) => void;
    onChagePostCode: (address: string) => void;
    onChageBase: (address: string) => void;
  };
  shape: "square" | "round";
}

const scriptUrl =
  "https://t1.daumcdn.net/mapjsapi/bundle/postcode/prod/postcode.v2.js";

// 주소 입력 폼 - 회원가입, 내정보 수정
const FormAddress = ({ className, addressState, chageEvent, shape }: Props) => {
  const { postCode, baseAddress, detailAddress } = addressState;
  const openDaumPost = useDaumPostcodePopup(scriptUrl);

  const handleComplete = (result: Address) => {
    chageEvent.onChagePostCode(result.zonecode);
    chageEvent.onChageBase(result.address);
  };

  return (
    <div className={`w-[342px] flex flex-col gap-1 ${className}`}>
      <div className="flex items-center gap-3">
        <InputText
          placeholder="우편번호"
          readOnly
          value={postCode}
          shape={shape}
        />
        <Btn.Line
          onClick={() => openDaumPost({ onComplete: handleComplete })}
          size="large"
          type="button"
          radiusFull={shape === "round"}
        >
          우편번호 찾기
        </Btn.Line>
      </div>
      <InputText
        placeholder="주소"
        readOnly
        value={baseAddress}
        shape={shape}
      />
      <InputText
        placeholder="상세 주소"
        value={detailAddress}
        onChange={(e) => chageEvent.onChageDetail(e.target.value)}
        shape={shape}
      />
    </div>
  );
};

export default FormAddress;
